import React from "react";
import CustomBox from "../CustomComponents/CustomBox/CustomBox";
import { useStyles } from "../../assets/jss/CustomLoader";
import Loader from "../../assets/images/loader.gif";

export default function CustomLoader(props:any) {
  const classes = useStyles();
  return (
    <CustomBox className={classes.customLoaderWrapper}>
      <img src={Loader} className={classes.pageLoaderImg} alt="" />
    </CustomBox>
  );
}
